const buildQuery = (query, token, proximity = undefined, includeAddress = false) => {
    let base_url = "https://api.mapbox.com/geocoding/v5/mapbox.places/";
    let types = `types=locality%2Cplace%2Cpostcode${includeAddress ? '%2Caddress' : ''}`
    base_url += `${query}.json?access_token=${token}&${types}`;

    if (proximity?.latitude && proximity.longitude) {
      base_url += `&proximity=${encodeURIComponent(`${proximity.longitude},${proximity.latitude}`)}`
    }else {

    }
    // const with_country = `${base_url}${query}.json?country=${country}&access_token=${token}&types=locality%2Cplace%2Cpostcode`;
    return base_url;
  };

  const getResults = async function(query, token, proximity = undefined, includeAddress = false) {
    if (query === "") {
      return {
        response: {
          features: []
        }
      };
    }

    try {
      const path = buildQuery(query, token, proximity, includeAddress);
      // Mapbox API returns an object which comes
      // with a .json() method which asynchronously
      // executes the query
      const testPath = await fetch(path, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      // Handle error if response is bad
      if (!testPath.ok) throw Error(testPath.statusText);

      // Execute query
      const queryResults = await testPath.json();
      return {
        response: queryResults
      };
    } catch (error) {
      return { error };
    }
  };

  export default getResults;